<template>
  <div class="container">
    <div class="searchBox">
      <el-form
        ref="searchForm" v-model="queryForm" :inline="false"
        label-position="top"
      >
        <el-row :gutter="50" type="flex" style="align-items: center;flex-wrap: wrap">
          <el-col :span="6">
            <!--母单状态-->
            <el-form-item :label="$t('navbar.cargoOrderStatus')">
              <el-select
                v-model="queryForm.params.cargoOrderStatus"
                :placeholder="$t('GlobalSetObj.all')"
                clearable
                filterable
                multiple
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in waybillStatusList"
                  :key="item.code"
                  :label="item.label"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--客户-->
            <el-form-item :label="$t('newOrder.CustomerName')">
              <template slot="label">
                <el-select
                  v-model="customerType"
                  :placeholder="$t('orderDetails.pleaseChoose')"
                  class="selectClass"
                  size="small"
                  @change="handleChangeCustomerType"
                >
                  <!--客户名称-->
                  <el-option :label="$t('newOrder.CustomerName')" :value="1" />
                  <!--客户渠道-->
                  <el-option :label="$t('customerManagements.customerChannel')" :value="2" />
                </el-select>
              </template>
              <el-select
                v-if="customerType === 1"
                v-model="queryForm.params.customerId"
                :placeholder="$t('spareNumberPoo.Only10AreDisplayed')"
                :remote-method="getCustomerPage"
                clearable
                filterable
                remote
                reserve-keyword
                size="small"
                style="width: 100%"
                @clear="getCustomerPage('')"
                @focus="getCustomerPage('', true)"
              >
                <el-option
                  v-for="item in customerList"
                  :key="item.id"
                  :label="item.customerAlias + '(' + item.username + ')'"
                  :value="item.id"
                />
              </el-select>
              <el-select
                v-if="customerType === 2"
                v-model="queryForm.params.customerChannel"
                :placeholder="$t('orderDetails.pleaseChoose')"
                clearable filterable
                style="width: 100%"
                @visible-change="getChannelData"
              >
                <el-option
                  v-for="(item, index) in channelList"
                  :key="index"
                  :label="item.value"
                  :value="item.key"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--发件人所属州-->
            <el-form-item :label="$t('navbar.senderState')">
              <el-select
                v-model="queryForm.params.senderStateList"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                multiple
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in StateList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.label"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--收件人所属州-->
            <el-form-item :label="$t('navbar.receiveState')">
              <el-select
                v-model="queryForm.params.receiveStateList"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                multiple
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in StateList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.label"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--收件人所属大区-->
            <el-form-item :label="$t('collectionCenter.recipientRegion')">
              <el-select
                v-model="queryForm.params.receiverRegionId"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in regionList"
                  :key="item.id"
                  :label="item.zhName + '（' + item.puName + '）'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--预派送网点-->
            <el-form-item :label="$t('GlobalSetObj.preEntrega')">
              <el-select
                v-model="queryForm.params.preDeliverStationId"
                :placeholder="$t('GlobalSetObj.OnlyAreDisplayed')"
                :remote-method="remoteGetSiteList"
                clearable
                filterable
                remote
                reserve-keyword
                size="small"
                style="width: 100%"
                @focus="remoteGetSiteList('')"
              >
                <el-option
                  v-for="item in siteList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--实际派送网点-->
            <el-form-item :label="$t('GlobalSetObj.entrega')">
              <el-select
                v-model="queryForm.params.deliverStationId"
                :placeholder="$t('GlobalSetObj.OnlyAreDisplayed')"
                :remote-method="remoteGetSiteList"
                clearable
                filterable
                remote
                reserve-keyword
                size="small"
                style="width: 100%"
                @focus="remoteGetSiteList('')"
              >
                <el-option
                  v-for="item in siteList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--派送区域类型-->
            <el-form-item :label="$t('collectionCenter.deliveryRegionType')">
              <el-select
                v-model="queryForm.params.deliveryAreaType"
                :placeholder="$t('GlobalSetObj.all')"
                clearable
                collapse-tags
                filterable
                size="small"
                style="width: 100%"
              >
                <el-option :label="$t('newOrder.all')" :value="null" />
                <el-option label="CAP" value="CAP" />
                <el-option label="INT" value="INT" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--标签-->
            <el-form-item :label="$t('navbar.tag')">
              <el-input
                v-model="queryForm.params.tag"
                :placeholder="$t('collectionCenter.pleaseInput')"
                clearable
                size="small"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--时间-->
            <el-form-item prop="searchTimeType">
              <template slot="label">
                <el-select
                  v-model="queryForm.params.searchTimeType"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  :style="IsWidthTime"
                  class="selectClass"
                  size="small"
                  @change="changeTimeType"
                >
                  <!--下单时间-->
                  <el-option key="1" :label="$t('GlobalSetObj.TimeOfOrder')" value="1" />
                  <!--签收时间-->
                  <el-option key="1" :label="$t('collectionCenter.signT')" value="2" />
                </el-select>
              </template>
              <el-date-picker
                v-model="timeValue"
                :default-time="['00:00:00', '23:59:59']"
                :end-placeholder="$t('operationCenter.endDate')"
                :format="$i18n.locale === 'zh' ? zhDate : ptDate"
                :start-placeholder="$t('operationCenter.startDate')"
                range-separator="~"
                size="small"
                style="width: 100%"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="changeTime"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <template slot="label">
                <el-select
                  v-model="queryForm.params.searchNumberType"
                  :placeholder="$t('orderDetails.pleaseChoose')"
                  :style="IsWidth"
                  class="selectClass"
                  size="small"
                >
                  <!--安骏订单号-->
                  <el-option key="1" :label="$t('navbar.anjunOrderNumber')" value="1" />
                  <!--安骏运单号-->
                  <el-option key="2" :label="$t('orderCenterCont.anjunWaybillNumber')" value="2" />
                </el-select>
              </template>
              <div style="width: 100%; margin-top: 5px">
                <el-input
                  v-model="queryForm.params.searchNumberStr"
                  :placeholder="$t('newOrder.PreciseSearch2')"
                  :rows="2"
                  size="small"
                  type="textarea"
                />
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div class="flx-between" style="margin-bottom: 10px">
              <div>
                <!--搜索-->
                <el-button size="small" type="primary" @click="enterGetSearch">{{ $t('newOrder.search') }}
                </el-button>
                <!--重置-->
                <el-button size="small" type="info" @click="resetData">{{ $t('newOrder.reset') }}
                </el-button>
                <el-radio-group
                  v-model="queryForm.params.orderWaybillType"
                  size="small"
                  style="margin-left: 10px"
                  @change="enterGetSearch"
                >
                  <el-radio-button :label="1">{{ $t('newOrder.Formal') }}</el-radio-button>
                  <el-radio-button :label="2">{{ $t('newOrder.test1') }}</el-radio-button>
                </el-radio-group>
              </div>
              <div>
                <!--      更多操作-->
                <el-popover placement="bottom" style="margin-right: 15px" trigger="hover">
                  <div>
                    <div style="margin-bottom: 10px">
                      <!-- 修改派送方式 -->
                      <el-button size="small" type="primary" @click="openModifyWindow">
                        {{ $t('collectionCenter.ModifyDeliveryMethod') }}
                      </el-button>
                    </div>
                    <div style="margin-bottom: 10px">
                      <!-- 修改收件信息 -->
                      <el-button
                        v-permit:remove="'btn:logisticsOrders:largeRecipientAddress'"
                        size="small"
                        type="primary"
                        @click="recipientAddress"
                      >
                        {{ $t('GlobalSetObj.fixaddress') }}
                      </el-button>
                    </div>
                    <div style="text-align: center; margin-bottom: 10px">
                      <!-- 大件取消订单 -->
                      <el-popconfirm
                        :hide-icon="true"
                        :title="$t('GlobalSetObj.cancelOrderSure')"
                        @confirm="cancelOrder"
                      >
                        <el-button
                          slot="reference"
                          v-permit:remove="'btn:logisticsOrders:largeCancelOrder'"
                          size="small"
                          type="primary"
                        >
                          {{ $t('collectionCenter.largeOrderCancel') }}
                        </el-button>
                      </el-popconfirm>
                    </div>
                    <div style="margin-bottom: 10px">
                      <!-- 订单信息导出 -->
                      <el-button
                        v-permit:remove="'btn:logisticsOrders:orderInfoExport'"
                        size="small"
                        type="success"
                        @click="allExportOrder"
                      >{{ $t('collectionCenter.orderInformationExport') }}
                      </el-button>
                    </div>
                    <div style="margin-bottom: 10px">
                      <!-- 运单信息导出 -->
                      <el-button
                        v-permit:remove="'btn:logisticsOrders:waybillInfoExport'"
                        size="small"
                        type="success"
                        @click="waybillInfoExport"
                      >{{ $t('collectionCenter.waybillInformationExport') }}
                      </el-button>
                    </div>
                    <div
                      v-permit:remove="'btn:logisticsOrders:abnormalPackageMark'"
                      style="margin-bottom: 10px"
                    >
                      <!--异常包裹标记 -->
                      <el-button size="small" type="primary" @click="abnormalPackageMark()">
                        {{ $t('collectionCenter.AbnormalPackageMark') }}
                      </el-button>
                    </div>
                  </div>
                  <el-button
                    slot="reference" size="small" style="margin-left: 10px"
                    type="primary"
                  >
                    {{ $t('orderCenterCont.moreActions') }}
                  </el-button>
                </el-popover>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-table
      ref="tableDataRef"
      :data="tableData"
      :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
      border
      max-height="600"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column fixed="left" type="selection" width="55" />
      <el-table-column
        :label="$t('GlobalSetObj.serial')"
        align="center"
        fixed="left"
        type="index"
        width="80"
      />
      <el-table-column
        v-for="item in tableHeaderList"
        :key="item.id"
        :align="item.center"
        :label="item.label"
        :min-width="item.cloWidth"
        :prop="item.prop"
        :show-overflow-tooltip="false"
      >
        <template slot-scope="scope">
          <div v-if="item.prop === 'customerName'">
            <el-popover placement="top" popper-class="copy" trigger="hover">
              <el-button class="copy-btn" type="text" @click="copy(scope.row.customerName)">
                {{ $t('orderDetails.copy') }}
              </el-button>
              <div slot="reference">
                {{ scope.row.customerName }}
              </div>
            </el-popover>
          </div>
          <div v-else-if="item.prop === 'customerNumber'">
            <el-popover placement="top" popper-class="copy" trigger="hover">
              <el-button class="copy-btn" type="text" @click="copy(scope.row.customerNumber)">
                {{ $t('orderDetails.copy') }}
              </el-button>
              <div slot="reference">
                {{ scope.row.customerNumber }}
              </div>
            </el-popover>
          </div>
          <div v-else-if="item.prop === 'orderNumber'">
            <el-popover placement="top" popper-class="copy" trigger="hover">
              <el-button class="copy-btn" type="text" @click="copy(scope.row.orderNumber)">
                {{ $t('orderDetails.copy') }}
              </el-button>
              <div slot="reference" class="textOrder" @click="toDetail(scope.row, 'xq')">
                {{ scope.row.orderNumber }}
              </div>
            </el-popover>
          </div>
          <div v-else-if="item.prop === 'waybillList'">
            <div v-if="scope.row.showWaybill === false">
              <div class="textOrder" @click="toDetail(scope.row, 'gj')">
                {{ scope.row.waybillList[0] }}
              </div>
              <div
                v-if="scope.row.waybillList.length > 1"
                class="textOrder"
                @click="scope.row.showWaybill = true"
              >
                ...{{ $t('orderCenterCont.expand') }}
              </div>
            </div>
            <div v-else>
              <div v-for="(items, index) in scope.row[item.prop]" :key="index">
                <div class="textOrder" @click="toDetail(scope.row, 'gj')">{{ items }}</div>
              </div>
            </div>
          </div>
          <div v-else-if="item.prop === 'totalFee'">
            <div
              @click="
                checkClick((queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1)
              "
            >
              <span
                v-if="
                  checkIndex ==
                    (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 &&
                    isCheckThis
                "
              >
                {{ scope.row[item.prop] }}&emsp;&emsp;
              </span>
              <span v-else>***&emsp;&emsp;</span>
              <span class="isFindClass">
                <sensitive-view-button
                  :revealed="checkIndex === (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 && isCheckThis"
                />
              </span>
            </div>
          </div>
          <div v-else-if="item.prop === 'abnormalWaybillList'">
            <div v-if="scope.row.showAbnormal === false">
              <div>
                {{ scope.row.abnormalWaybillList[0] }}
              </div>
              <div
                v-if="scope.row.abnormalWaybillList.length > 1"
                class="textOrder"
                @click="scope.row.showAbnormal = true"
              >
                ...{{ $t('orderCenterCont.expand') }}
              </div>
            </div>
            <div v-else>
              <div v-for="(items, index) in scope.row.abnormalWaybillList" :key="index">
                <div>{{ items }}</div>
              </div>
            </div>
          </div>
          <div v-else-if="item.prop === 'delivererName'">
            <div v-if="scope.row.showDeliverer === false">
              <div>
                {{ scope.row.delivererList[0] }}
              </div>
              <div
                v-if="scope.row.delivererList.length > 1"
                class="textOrder"
                @click="scope.row.showDeliverer = true"
              >
                ...{{ $t('orderCenterCont.expand') }}
              </div>
            </div>
            <div v-else>
              <div v-for="(items, index) in scope.row.delivererList" :key="index">
                <div>{{ items }}</div>
              </div>
            </div>
          </div>
          <div v-else-if="item.prop === 'tags'">
            <span v-if="scope.row.tags && scope.row.tags.length > 0">
              <span v-for="(tag, index) in scope.row.tags" :key="index" class="tag_class">
                {{ tag }}
              </span>
            </span>
            <span v-else>--</span>
          </div>
          <div v-else-if="item.prop === 'cteInvoiceKeyList'">
            <div v-if="scope.row.cteInvoiceKeyList && scope.row.cteInvoiceKeyList.length > 0">
              <el-popover placement="top" popper-class="copy" trigger="hover">
                <el-button class="copy-btn" type="text" @click="copy(scope.row.cteInvoiceKeyList)">
                  {{ $t('orderDetails.copy') }}
                </el-button>
                <div slot="reference">
                  <div v-for="(items, index) in scope.row.cteInvoiceKeyList" :key="index">
                    <div>{{ items }}</div>
                  </div>
                </div>
              </el-popover>
            </div>
            <div v-else>--</div>
          </div>
          <div v-else>
            {{
              !scope.row[item.prop] && scope.row[item.prop] !== 0 ? '--' : `${scope.row[item.prop]}`
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('newOrder.operation')" align="center" fixed="right"
        width="150"
      >
        <template slot-scope="scope">
          <div style="display: flex; justify-content: space-around; align-items: center">
            <el-tooltip
              :content="$t('GlobalSetObj.details')"
              class="item"
              effect="dark"
              placement="top"
            >
              <i class="iconfont icon-chakan textOperator" @click="toDetail(scope.row, 'xq')" />
            </el-tooltip>
            <el-tooltip
              :content="$t('navbar.tag')" class="item" effect="dark"
              placement="top"
            >
              <span
                class="textOperator tag"
                style="margin-left: 10px"
                @click="toTagOpen(scope.row)"
              >
                <svg-icon icon-class="tag" style="font-size: 16px" />
              </span>
            </el-tooltip>
            <!--            <el-tooltip-->
            <!--              :content="$t('GlobalSetObj.TrackSearch')"-->
            <!--              class="item"-->
            <!--              effect="dark"-->
            <!--              placement="top"-->
            <!--            >-->
            <!--              <i-->
            <!--                class="iconfont icon-a-zu231 textOperator"-->
            <!--                style="margin-left: 10px"-->
            <!--                @click="toDetail(scope.row, 'gj')"-->
            <!--              />-->
            <!--            </el-tooltip>-->
            <el-tooltip
              :content="$t('newOrder.orderNote')"
              class="item"
              effect="dark"
              placement="top"
            >
              <span
                class="el-icon-edit textOperator"
                style="margin-left: 10px"
                @click="toRemarks(scope.row)"
              />
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page.sync="queryForm.pageNumber"
      :page-size.sync="queryForm.pageSize"
      :page-sizes="[10, 50, 100, 200, 400]"
      :total="queryForm.total"
      background
      layout="total, sizes, prev, pager, next, jumper"
      style="margin: 20px 0; text-align: right"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
    <!--大件订单详情-->
    <el-drawer
      :append-to-body="true"
      :visible.sync="detailDialog"
      custom-class="drawerClass"
      direction="ltr"
      size="80%"
      @close="handledetailDialog"
    >
      <template #title>
        <div>
          <span style="margin-right: 20px">{{ $t('collectionCenter.largeOrderDetails') }}</span>
          <span style="margin-right: 10px"> {{ `${detailDialogObj.orderNumber}` }}</span>
          <span>({{ $t('navbar.gong') }} {{ detailDialogObj.totalNumber }}
            {{ $t('navbar.jian') }})</span>
        </div>
      </template>
      <!-- 大件详情   -->
      <Detail
        :key="keyChange"
        ref="Detail"
        :grandson="DetailId"
        :open-idx="openType"
        :remark-id="form.orderId"
        :waybill-list="waybillList"
      />
    </el-drawer>
    <!-- 备注 -->
    <el-dialog
      :before-close="remarksClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('collectionCenter.Note')"
      :visible.sync="remarksDialogVisible"
      width="30%"
    >
      <el-form ref="remarksRef" :model="form" class="remarks_class">
        <el-row>
          <el-col :span="24">
            <el-form-item
              :rules="{
                required: true,
                message: $t('collectionCenter.pleaseEnterRemarks'),
                trigger: ['change']
              }"
              prop="remark"
            >
              <el-input
                v-model="form.remark"
                :placeholder="$t('collectionCenter.inputPrompt')"
                clearable
                maxlength="200"
                show-word-limit
                type="textarea"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitRemark">{{
          $t('collectionCenter.confirm')
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 修改派送方式 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('collectionCenter.ModifyDeliveryMethod')"
      :visible.sync="showModifyWindow"
      width="500px"
      @close="closeModifyWindow"
    >
      <div style="margin-bottom: 30px">
        <div style="margin-bottom: 10px">
          {{ $t('GlobalSetObj.Selecionadas') }}：{{ selectionList.length }}
        </div>
        <el-form
          ref="modifyDeliveryMethod"
          :model="modifyForm"
          class="remarks_class"
          label-position="top"
          size="small"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item
                :label="$t('collectionCenter.ModifyDeliveryMethod')"
                :rules="{
                  required: true,
                  message: $t('collectionCenter.notNull'),
                  trigger: ['change']
                }"
                prop="deliveryMethod"
              >
                <el-select
                  v-model="modifyForm.deliveryMethod"
                  :placeholder="$t('collectionCenter.pleaseChoose')"
                  style="width: 100%"
                >
                  <el-option
                    :key="1"
                    :label="$t('collectionCenter.HoldForCompleteDelivery')"
                    :value="1"
                  /><!--到齐再派-->
                  <el-option
                    :key="2"
                    :label="$t('collectionCenter.firstComeFirstServeDelivery')"
                    :value="2"
                  />
                  <!--先到先派-->
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeModifyWindow">{{
          $t('collectionCenter.cancel')
        }}</el-button>
        <el-button size="small" type="primary" @click="submitModifyForm">{{
          $t('collectionCenter.confirm')
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 修改派送方式结果 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :title="$t('collectionCenter.tips')"
      :visible.sync="showModifyWindowResult"
      width="600px"
    >
      <div>
        <div style="margin-bottom: 20px; font-weight: bold">
          {{ $t('newOrder.OperationSuccessful') }}！
        </div>
        <div style="display: flex; margin-bottom: 20px">
          <div style="width: 140px">{{ $t('newOrder.all') }}：{{ modifyResult.all }}</div>
          <div style="flex: 1">
            {{ $t('newOrder.TheUpdateWasSuccessful') }}：{{ modifyResult.success }}
          </div>
          <div style="flex: 1">{{ $t('newOrder.TheUpdateFailed') }}：{{ modifyResult.fail }}</div>
        </div>
        <div v-if="modifyResult.errorList.length > 0">
          <div style="margin-bottom: 10px; font-weight: bold">
            {{ $t('GlobalSetObj.ReasonForFailure') }}：
          </div>
          <div
            v-for="(item, index) in modifyResult.errorList"
            :key="index"
            style="margin-bottom: 10px"
          >
            {{ item }}
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="closeModifyResult">{{
          $t('orderExport.close')
        }}</el-button>
      </span>
    </el-dialog>
    <!--  修改收件信息  -->
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :show-close="true"
      :title="$t('GlobalSetObj.fixaddress')"
      :visible.sync="fixAddress"
      top="5vh"
      width="900px"
      @close="clearForm"
    >
      <editBigExpressAddress
        :key="fixAddress"
        ref="editRecipientInformationRef"
        :change-type="2"
        :old-zip-code="oldZipCode"
        :recevice-rule-form="receviceRuleForm"
        :selection-list="selectionList"
        :sender-state-list="senderStateList"
        @updateTable="updateTableData"
      />
      <div style="text-align: center">
        <el-button @click="fixAddress = false">{{ $t('GlobalSetObj.Cancelar') }}</el-button>
        <el-button type="primary" @click="comfireFixAddress">{{ $t('GlobalSetObj.determine') }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 提示 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('GlobalSetObj.tips')"
      :visible.sync="tipDialog"
      width="800px"
    >
      <el-row :gutter="10" style="font-size: 16px !important">
        <el-col :span="8">{{ $t('GlobalSetObj.fixTotal') }}:<span class="tipclass">{{
          tipDialogData.updateTotal
        }}</span></el-col>
        <el-col :span="8">{{ $t('GlobalSetObj.ModificationSuccessful') }}:<span class="tipclass">{{
          tipDialogData.successTotal
        }}</span></el-col>
        <el-col :span="8">{{ $t('GlobalSetObj.failTotal') }}:<span class="tipclass" style="color: red">{{
          tipDialogData.failTotal
        }}</span></el-col>
      </el-row>
      <div
        style="
          margin-top: 20px;
          font-size: 16px;
          line-height: 30px;
          height: 200px;
          overflow-y: auto;
        "
      >
        <div v-if="tipDialogData.failTotal">
          <div>{{ $t('GlobalSetObj.notFix') }}:</div>
          <div v-for="(item, index) in tipDialogData.errorList" :key="index">
            <span>{{ index + 1 }}.</span>
            <span>{{ item.waybillNumber }}</span>
            <span style="margin-left: 10px">{{ item.errorMessage }}</span>
          </div>
        </div>
      </div>
      <div style="text-align: center; margin: 15px 0">
        <el-button size="small" type="primary" @click="tipDialog = false">{{ $t('GlobalSetObj.determine') }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 异常包裹标记 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('collectionCenter.AbnormalPackageMark')"
      :visible.sync="showAbnormalPackageMarkWindow"
      width="600px"
    >
      <div>
        <abnormal-package-mark
          :key="showAbnormalPackageMarkWindow"
          ref="abnormalPackageMarkRef"
          @updateTable="updateTableAbnormal"
        />
      </div>
    </el-dialog>

    <!-- 大件取消订单 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('collectionCenter.largeOrderCancel')"
      :visible.sync="coDialog"
      width="550px"
      @close="clearProgress"
    >
      <div>
        <el-progress
          :class="coProgress === 100 ? 'is-success' : ''"
          :format="formatProgress"
          :percentage="100"
          :stroke-width="10"
          style="margin: 20px 0 10px"
        />
      </div>
      <div style="margin-bottom: 10px">
        <sapn>{{ $t('operationCenter.succeed') }}：<span style="color: #61ceae">{{
          coList.successCount || 0
        }}</span>
        </sapn>
        <sapn style="margin-left: 30px">{{ $t('operationCenter.fail') }}：<span style="color: #cc3b3b">{{
          coList.failuresCount || 0
        }}</span></sapn>
      </div>
      <div v-if="coList.failuresMap && Object.keys(coList.failuresMap).length > 0">
        <span style="display: inline-block">{{ $t('collectionCenter.failureDetails') }}：</span>
        <div v-for="(errorMessage, waybillNumber) in coList.failuresMap" :key="waybillNumber">
          {{ waybillNumber }}：<span style="color: black">{{ errorMessage }}</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="clearProgress">{{
          $t('collectionCenter.close')
        }}</el-button>
      </span>
    </el-dialog>

    <!-- 增加标签 -->
    <el-dialog
      :before-close="tagClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('collectionCenter.addLabel')"
      :visible.sync="tagDialogVisible"
      class="dialogBox"
      width="35%"
    >
      <div class="tag_dialog">
        {{ $t('navbar.tag') }}：
        <el-input
          v-model="tagForm.tagName"
          :placeholder="$t('collectionCenter.labelInputHint')"
          clearable
          maxlength="6"
          size="small"
          style="flex: 1"
        />
      </div>
      <div v-if="hisTagList.length > 0" style="margin-left: 20px">
        <div style="font-size: 15px; font-weight: bold; margin-bottom: 10px">
          {{ $t('collectionCenter.historyTags') }}：
        </div>
        <span v-for="(item, idx) in hisTagList" :key="idx">
          <span class="tag_class span" @click="tagCopy(item)">{{ item }}</span>
        </span>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="tagClose">
          {{ $t('GlobalSetObj.cancel') }}
        </el-button>
        <el-button size="small" type="primary" @click="tagSubmit">
          {{ $t('collectionCenter.Save') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiCustomerPage, getCustomerChannelList } from '@/api/customer';
import { siteFuzzyQuery } from '@/api/lanshou';
import { headerList, waybillStatusList } from './tableHeadListData/index';
import dayjs from 'dayjs';
import { getLgAreaListData, regionQueryList } from '@/api/orderApi';
import {
  cancelAbolish,
  cargoExportAll,
  cargoOrderRemark,
  getServiceList,
  historicalTagsQuery,
  historicalTagsSbm,
  modifyDeliveryMethod,
  waybillExportAll
} from '@/api/bulkExpressApi';
import { goResourceTaskList } from '@/utils/goExportList';
import { waybillStatusObj } from '@/utils/enumData';
import abnormalPackageMark from './component/abnormalPackageMark.vue';

import Detail from './component/detail';
import editBigExpressAddress from '@/views/orderCenter/logisticsOrders/components/editBigExpressAddress.vue';
import { sensitiveViewPlaintext } from '@/api/user';
import { copyData } from '@/utils/copyData';
import SensitiveViewButton from '@/components/SensitiveViewButton/index.vue';

export default {
  name: 'LargeOrderManagement',
  components: {
    abnormalPackageMark,
    editBigExpressAddress,
    Detail,
    SensitiveViewButton
  },
  props: {
    senderStateList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      channelList: [],
      customerType: 1,
      hisTagList: [],
      tagForm: {
        orderId: null,
        tagName: ''
      },
      tagDialogVisible: false,
      regionList: [],
      // 取消订单
      coDialog: false,
      coProgress: 0,
      coList: {},
      rowCode: {},
      form: {
        orderId: null,
        remark: ''
      },
      remarksDialogVisible: false,
      checkIndex: -1,
      isCheckThis: false,
      waybillList: '',
      openType: 'xq', // 详情 / 轨迹
      StateList: [],
      // 是否格式化成巴西时间
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      isTormat: false,
      timeValue: [],
      tableHeaderList: headerList,
      tableData: [],
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          cargoOrderStatus: [],
          senderStateList: [],
          receiveStateList: [],
          receiverRegionId: null,
          // collectStationId: null,
          preDeliverStationId: null,
          deliverStationId: null,
          searchTimeType: '1',
          searchNumberType: '1',
          customerId: '',
          customerChannel: '',
          searchNumberStr: '',
          tag: '',
          orderWaybillType: 1,
          deliveryAreaType: null
        }
      },
      // 勾选表格数据
      selectionList: [],
      customerList: [],
      waybillStatusList: waybillStatusList,
      DetailId: 0,
      detailDialog: false,
      siteList: [],
      detailDialogObj: {},
      keyChange: '',
      showModifyWindow: false,
      modifyForm: {
        cargoOrderIds: [],
        deliveryMethod: null
      },
      showModifyWindowResult: false,
      modifyResult: {
        all: 0,
        success: 0,
        fail: 0,
        errorList: []
      },
      fixAddress: false,
      receviceRuleForm: {
        receiveTax: '',
        receiveMobile: '',
        receiveName: '',
        receiveZipcode: '', // 邮编
        receiveStreet: '', // 街道（精确到街道号）
        receiveHouseNumber: '', // 门牌号
        receiveState: '', // 州
        receiveCity: '', // 城市
        receiveArea: '', // 区
        receiveComplement: '',
        receiveAddress: '' // 详细地址
      },
      oldZipCode: null,
      tipDialog: false, // 修改收件地址提示
      tipDialogData: {},
      showAbnormalPackageMarkWindow: false
    };
  },
  computed: {
    IsWidth() {
      return {
        width: this.isTormat ? '250px' : '130px'
      };
    },
    IsWidthTime() {
      return {
        width: this.isTormat ? '200px' : '150px'
      };
    }
  },
  created() {
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
    this.getTimer();
    this.getSearch();
    this.getRegion();
    this.getChannel();
  },
  mounted() {
    this.getState();
    this.bus.$on('updateTableList', () => {
      this.getSearch();
    });
  },
  methods: {
    handleChangeCustomerType() {
      this.queryForm.params.customerId = '';
      this.queryForm.params.customerChannel = '';
    },
    getChannelData() {
      if (this.channelList.length <= 0) {
        this.getChannel();
      }
    },
    getChannel() {
      getCustomerChannelList().then((res) => {
        if (res.code === 200) {
          this.channelList = res.data || [];
        }
      });
    },
    // 点击复制
    copy(data) {
      copyData(data);
    },
    tagCopy(item) {
      this.tagForm.tagName = item;
    },
    toTagOpen(row) {
      this.tagForm.orderId = row.id;
      const wn = row.id;
      historicalTagsQuery(wn).then((res) => {
        if (res.code === 200) {
          this.tagDialogVisible = true;
          this.hisTagList = res.data || [];
        }
      });
    },
    tagClose() {
      this.tagForm = {
        orderId: null,
        tagName: ''
      };
      this.hisTagList = [];
      this.tagDialogVisible = false;
    },
    tagSubmit() {
      if (!this.tagForm.tagName) {
        this.$message.warning(this.$t('collectionCenter.enterOrSelectLabel'));
        return;
      }
      historicalTagsSbm(this.tagForm).then((res) => {
        if (res.code === 200) {
          this.$message.success(this.$t('basicData.TheOperationSucceeded')); // 操作成功
          this.tagClose();
          this.getSearch();
        }
      });
    },
    // 大区
    getRegion() {
      regionQueryList('').then((res) => {
        if (res.code === 200) {
          this.regionList = res.data;
        }
      });
    },
    formatProgress(val) {
      // 处理中  /  100%
      if (val < 100) {
        return this.$t('newOrder.processing');
      } else {
        return '100%';
      }
    },
    // 取消订单
    cancelOrder() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.$t('receivablePayable.SelectAtLeastOnePieceOfData'));
        return;
      }
      this.coDialog = true;
      let progress = 0;
      const interval = setInterval(() => {
        if (this.coProgress < 90) {
          progress += 10;
        }
        this.coProgress = progress;
      }, 300);
      const orderIds = this.selectionList.map((item) => item.id);
      const idForm = {
        orderIds
      };
      cancelAbolish(idForm)
        .then((res) => {
          if (res.code === 200) {
            this.coProgress = 100;
            this.coList = res.data;
          }
        })
        .finally(() => {
          clearInterval(interval);
        });
    },
    clearProgress() {
      this.coDialog = false;
      this.coProgress = 0;
      this.getSearch();
    },
    // 打开异常包裹标记弹窗
    abnormalPackageMark() {
      this.showAbnormalPackageMarkWindow = true;
    },
    // 关闭异常包裹标记弹窗并更新列表数据
    updateTableAbnormal(type) {
      this.showAbnormalPackageMarkWindow = false;
      if (type) {
        this.getSearch();
      }
    },
    changeTimeType() {
      this.getTimer();
      if (this.timeValue && this.timeValue.length > 0) {
        if (this.queryForm.params.searchTimeType === '1') {
          this.queryForm.params.createBeginTime = this.timeValue[0];
          this.queryForm.params.createEndTime = this.timeValue[1];
        } else {
          this.queryForm.params.signBeginTime = this.timeValue[0];
          this.queryForm.params.signEndTime = this.timeValue[1];
        }
      }
    },
    changeTime(val) {
      if (val === null) {
        this.timeValue = [];
        this.queryForm.params.createBeginTime = '';
        this.queryForm.params.createEndTime = '';
        this.queryForm.params.signBeginTime = '';
        this.queryForm.params.signEndTime = '';
        return;
      }
      if (this.queryForm.params.searchTimeType === '1') {
        this.queryForm.params.createBeginTime = val[0];
        this.queryForm.params.createEndTime = val[1];
      } else {
        this.queryForm.params.signBeginTime = val[0];
        this.queryForm.params.signEndTime = val[1];
      }
    },
    comfireFixAddress() {
      this.$refs.editRecipientInformationRef.confirmEdit();
    },
    // 修改收件地址信息后更新列表数据
    updateTableData(tipDialogData, tipDialog) {
      this.tipDialogData = tipDialogData;
      this.fixAddress = false;
      this.$nextTick(() => {
        this.tipDialog = tipDialog;
      });
      this.getSearch();
      this.$refs['tableDataRef'].toggleSelection();
    },
    // 关闭弹窗后重置修改收件地址信息表单
    clearForm() {
      Object.assign(this.receviceRuleForm, {
        receiveTax: '',
        receiveMobile: '',
        receiveName: '',
        receiveZipcode: '', // 邮编
        receiveStreet: '', // 街道（精确到街道号）
        receiveHouseNumber: '', // 门牌号
        receiveState: '', // 州
        receiveCity: '', // 城市
        receiveArea: '', // 区
        receiveComplement: ''
      });
    },
    // 修改收件地址信息
    recipientAddress() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.$t('collectionCenter.checkMsg'));
        return;
      }
      if (this.selectionList.length === 1) {
        const selected = this.selectionList[0];
        this.fixAddress = false;
        sensitiveViewPlaintext({ data: selected }).then((res) => {
          if (this.selectionList.length !== 1 || this.selectionList[0] !== selected) return;
          this.receviceRuleForm = res.data;
          this.oldZipCode = res.data.receiveZipcode;
          this.fixAddress = true;
        }).catch(() => {
          this.fixAddress = false;
        });
      } else {
        this.receviceRuleForm = {
          receiveTax: '',
          receiveMobile: '',
          receiveName: '',
          receiveZipcode: '', // 邮编
          receiveStreet: '', // 街道（精确到街道号）
          receiveHouseNumber: '', // 门牌号
          receiveState: '', // 州
          receiveCity: '', // 城市
          receiveArea: '', // 区
          receiveComplement: '',
          receiveAddress: '' // 详细地址
        };
        this.fixAddress = true;
      }
    },
    // 关闭修改派送方式结果弹窗
    closeModifyResult() {
      this.showModifyWindowResult = false;
      this.showModifyWindow = false;
      this.modifyResult = {
        all: 0,
        success: 0,
        fail: 0,
        errorList: []
      };
      this.closeModifyWindow();
      this.getSearch();
    },
    // 关闭修改派送方式弹窗
    closeModifyWindow() {
      this.modifyForm.deliveryMethod = null;
      this.modifyForm.cargoOrderIds = [];
      this.$refs.modifyDeliveryMethod.resetFields();
      this.showModifyWindow = false;
    },
    // 打开修改派送方式弹窗
    openModifyWindow() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.$t('collectionCenter.checkMsg'));
        return;
      }
      this.modifyForm.cargoOrderIds = this.selectionList.map((item) => item.id);
      this.showModifyWindow = true;
    },
    // 确定修改派送方式
    submitModifyForm() {
      this.$refs.modifyDeliveryMethod.validate((valid) => {
        if (valid) {
          modifyDeliveryMethod(this.modifyForm).then((res) => {
            if (res.code === 200) {
              this.modifyResult = {
                all: res.data.total,
                success: res.data.successTotal,
                fail: res.data.failTotal,
                errorList: res.data.errorList
              };
              this.showModifyWindowResult = true;
            }
          });
        }
      });
    },
    toRemarks(row) {
      this.rowCode = row;
      this.form.orderId = row.id;
      this.remarksDialogVisible = true;
    },
    remarksClose() {
      this.remarksDialogVisible = false;
      this.$refs.remarksRef.clearValidate();
      this.$refs.remarksRef.resetFields();
    },
    submitRemark() {
      this.$refs.remarksRef.validate((valid) => {
        if (valid) {
          cargoOrderRemark(this.form).then((res) => {
            if (res.code === 200) {
              this.remarksClose();
              // 保存成功后跳转到详情页-备注记录
              this.toDetail(this.rowCode, 'bz');
              this.$message.success(this.$t('basicData.TheOperationSucceeded')); // 操作成功
            }
          });
        }
      });
    },
    checkClick(idx) {
      const hasPermission = this.$store.getters.button_permissions.includes(
        'but:collection-center:largeOrderManagement:check'
      );
      if (!hasPermission) {
        this.$message.error(this.$t('GlobalSetObj.sensitiveInfoPermission'));
        return;
      }
      if (this.checkIndex !== idx) {
        this.isCheckThis = true;
      } else {
        this.isCheckThis = !this.isCheckThis;
      }
      this.checkIndex = idx;
    },
    // 勾选
    handleSelectionChange(data) {
      this.selectionList = data;
    },
    // 搜索
    getSearch() {
      const data = {
        pageNumber: this.queryForm.pageNumber,
        pageSize: this.queryForm.pageSize,
        params: {
          cargoOrderStatus: this.queryForm.params.cargoOrderStatus || [],
          senderStateList: this.queryForm.params.senderStateList || [],
          customerId: this.queryForm.params.customerId || null,
          customerChannel: this.queryForm.params.customerChannel || null,
          receiveStateList: this.queryForm.params.receiveStateList || [],
          receiverRegionId: this.queryForm.params.receiverRegionId || null,
          // collectStationId: this.queryForm.params.collectStationId || null,
          preDeliverStationId: this.queryForm.params.preDeliverStationId || null,
          deliverStationId: this.queryForm.params.deliverStationId || null,
          createBeginTime: '',
          createEndTime: '',
          signBeginTime: '',
          signEndTime: '',
          tag: this.queryForm.params.tag || '',
          orderWaybillType: this.queryForm.params.orderWaybillType,
          deliveryAreaType: this.queryForm.params.deliveryAreaType || null
        }
      };
      if (this.queryForm.params.searchNumberStr) {
        if (this.queryForm.params.searchNumberType === '1') {
          data.params.orderNumberList = this.queryForm.params.searchNumberStr.split('\n');
        } else if (this.queryForm.params.searchNumberType === '2') {
          data.params.waybillNumberList = this.queryForm.params.searchNumberStr.split('\n');
        } else {
          data.params.providerNumberList = this.queryForm.params.searchNumberStr.split('\n');
        }
      }
      if (this.timeValue && this.timeValue.length > 0) {
        if (this.queryForm.params.searchTimeType === '1') {
          data.params.createBeginTime = this.timeValue[0];
          data.params.createEndTime = this.timeValue[1];
        } else {
          data.params.signBeginTime = this.timeValue[0];
          data.params.signEndTime = this.timeValue[1];
        }
      } else {
        if (!this.queryForm.params.searchNumberStr) {
          this.$message.warning(this.$t('collectionCenter.PleaseSelectTime'));
          return;
        }
      }
      getServiceList(data).then((res) => {
        if (res.code === 200) {
          this.queryForm.total = res.data.total;
          res.data.records.map((item) => {
            item.showWaybill = false;
            item.showDeliverer = false;
            item.showAbnormal = false;
            try {
              item.tags = item.tags ? JSON.parse(item.tags) : [];
            } catch (e) {
              item.tags = [];
            }
          });
          this.tableData = res.data.records;
          this.tableData.forEach((item) => {
            try {
              item['waybillStatusName'] = waybillStatusObj[item.waybillStatus].label;
            } catch (e) {
              item['waybillStatusName'] = '--';
            }
          });
        }
      });
    },
    handledetailDialog() {
      this.detailDialog = false;
      this.openType = '';
      this.getSearch();
    },
    toDetail(row, type) {
      this.form.orderId = row.id;
      this.DetailId = row.id;
      this.keyChange = new Date().getTime();
      this.detailDialogObj = {
        totalNumber: row.totalNumber,
        orderNumber: row.orderNumber
      };
      this.waybillList = row.waybillList;
      this.openType = type;
      this.detailDialog = true;
    },
    // 获取客户选项
    getCustomerPage(name = '', flag) {
      const param = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          quickSearch: ''
        }
      };
      if (flag) {
        if (this.customerList.length === 0) {
          apiCustomerPage(param).then((res) => {
            if (res.code === 200) {
              this.customerList = res.data.records;
            }
          });
        }
      } else {
        param.params.quickSearch = name;
        apiCustomerPage(param).then((res) => {
          if (res.code === 200) {
            this.customerList = res.data.records;
          }
        });
      }
    },
    // 订单信息导出
    allExportOrder() {
      const data = {
        cargoOrderStatus: this.queryForm.params.cargoOrderStatus || [],
        senderStateList: this.queryForm.params.senderStateList || [],
        customerId: this.queryForm.params.customerId || null,
        customerChannel: this.queryForm.params.customerChannel || null,
        receiveStateList: this.queryForm.params.receiveStateList || [],
        receiverRegionId: this.queryForm.params.receiverRegionId || null,
        // collectStationId: this.queryForm.params.collectStationId || null,
        preDeliverStationId: this.queryForm.params.preDeliverStationId || null,
        deliverStationId: this.queryForm.params.deliverStationId || null,
        createBeginTime: '',
        createEndTime: '',
        signBeginTime: '',
        signEndTime: '',
        tag: this.queryForm.params.tag || '',
        orderWaybillType: this.queryForm.params.orderWaybillType,
        deliveryAreaType: this.queryForm.params.deliveryAreaType || null
      };
      if (this.queryForm.params.searchNumberStr) {
        if (this.queryForm.params.searchNumberType === '1') {
          data.orderNumberList = this.queryForm.params.searchNumberStr.split('\n');
        } else if (this.queryForm.params.searchNumberType === '2') {
          data.waybillNumberList = this.queryForm.params.searchNumberStr.split('\n');
        } else {
          data.providerNumberList = this.queryForm.params.searchNumberStr.split('\n');
        }
      }
      if (this.timeValue && this.timeValue.length > 0) {
        if (this.queryForm.params.searchTimeType === '1') {
          data.createBeginTime = this.timeValue[0];
          data.createEndTime = this.timeValue[1];
        } else {
          data.signBeginTime = this.timeValue[0];
          data.signEndTime = this.timeValue[1];
        }
      } else {
        if (!this.queryForm.params.searchNumberStr) {
          this.$message.warning(this.$t('collectionCenter.PleaseSelectTime'));
          return;
        }
      }
      cargoExportAll(data).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },

    // 运单信息导出
    waybillInfoExport() {
      const data = {
        cargoOrderStatus: this.queryForm.params.cargoOrderStatus || [],
        senderStateList: this.queryForm.params.senderStateList || [],
        customerId: this.queryForm.params.customerId || null,
        customerChannel: this.queryForm.params.customerChannel || null,
        receiveStateList: this.queryForm.params.receiveStateList || [],
        receiverRegionId: this.queryForm.params.receiverRegionId || null,
        // collectStationId: this.queryForm.params.collectStationId || null,
        preDeliverStationId: this.queryForm.params.preDeliverStationId || null,
        deliverStationId: this.queryForm.params.deliverStationId || null,
        createBeginTime: '',
        createEndTime: '',
        tag: this.queryForm.params.tag || '',
        orderWaybillType: this.queryForm.params.orderWaybillType,
        deliveryAreaType: this.queryForm.params.deliveryAreaType || null
      };
      if (this.queryForm.params.searchNumberStr) {
        if (this.queryForm.params.searchNumberType === '1') {
          data.orderNumberList = this.queryForm.params.searchNumberStr.split('\n');
        } else if (this.queryForm.params.searchNumberType === '2') {
          data.waybillNumberList = this.queryForm.params.searchNumberStr.split('\n');
        } else {
          data.providerNumberList = this.queryForm.params.searchNumberStr.split('\n');
        }
      }
      if (this.timeValue && this.timeValue.length > 0) {
        data.createBeginTime = this.timeValue[0];
        data.createEndTime = this.timeValue[1];
      } else {
        if (!this.queryForm.params.searchNumberStr) {
          this.$message.warning(this.$t('collectionCenter.PleaseSelectTime'));
          return;
        }
      }
      waybillExportAll(data).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    // 分页
    handleSizeChange(val) {
      this.queryForm.pageNumber = 1;
      this.queryForm.pageSize = val;
      this.getSearch();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getSearch();
    },
    // 州
    getState() {
      // level 0 州    1 城市   2 地区
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.StateList = res.data.map((item) => {
            return {
              id: item.id,
              label: `${item.nameEn}`
            };
          });
        }
      });
    },
    // 获取最近一星期时间
    getTimer() {
      // const day = new Date();
      // const brazilTime = day.toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' });
      const today = dayjs().format('YYYY-MM-DD');
      const oneWeekAgo = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
      this.timeValue = [today + ' 00:00:00', today + ' 23:59:59'];
    },
    remoteGetSiteList(val) {
      const value = val || '';
      siteFuzzyQuery(value).then((res) => {
        if (res.code === 200) {
          this.siteList = res.data;
        }
      });
    },
    resetData() {
      // 使用默认值重置 queryForm
      const defaultParams = {
        cargoOrderStatus: [],
        senderStateList: [],
        receiveStateList: [],
        receiverRegionId: null,
        // collectStationId: null,
        preDeliverStationId: null,
        deliverStationId: null,
        searchTimeType: '1',
        searchNumberType: '1',
        customerId: '',
        customerChannel: '',
        tag: '',
        searchNumberStr: '',
        orderWaybillType: 1,
        deliveryAreaType: null
      };
      this.getTimer();
      this.queryForm = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          ...defaultParams
        }
      };
      this.getSearch();
      this.getCustomerPage('');
    },
    enterGetSearch() {
      this.queryForm.pageNumber = 1;
      this.getSearch();
    }
  }
};
</script>

<style scoped>
.el-progress >>> .el-progress-bar__inner {
  background-color: #67c13a !important;
}

.el-progress >>> .el-progress-bar {
  display: block;
  padding-right: 0 !important;
}

.el-progress >>> .el-progress__text {
  position: absolute;
  top: -20px;
  right: 0;
}

.el-progress >>> .el-progress__text {
  color: #57aaff !important;
}

.el-progress.is-success >>> .el-progress__text {
  color: black !important;
}

.remarks_class >>> .el-textarea .el-input__count {
  bottom: 3px !important;
  line-height: 12px;
  background: rgba(0, 0, 0, 0);
}

.isFindClass {
  margin-right: 8px;
}

.searchBox >>> .selectClass .el-input__inner {
  border: none !important;
  color: #4e5969;
  font-size: 14px;
}

.span.tag_class {
  display: inline-block;
  margin-right: 20px;
  padding: 1px 10px;
  cursor: pointer;
}

.tag_class {
  color: #ff810d;
  background: #ffeede;
  margin-right: 5px;
  padding: 1px 5px;
  border-radius: 3px;
  box-sizing: border-box;
}

.textOperator.tag {
  position: relative;

  &::before {
    content: '+';
    position: absolute;
    right: 1px;
    top: -5px;
    font-size: 19px;
    line-height: 19px;
    color: #00a551;
    text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
  }
}

.textOperator {
  font-size: 20px;
  color: #00a551;
  cursor: pointer;
}

.textOrder {
  color: #00a551;
  cursor: pointer;
}

.dialogBox >>> .el-dialog__body {
  min-height: 200px;
}

.tag_dialog {
  display: flex;
  align-items: center;
  margin: 20px;
  font-size: 15px;
  font-weight: bold;
  position: relative;

  &::before {
    position: absolute;
    left: -10px;
    top: 50%;
    transform: translateY(-50%);
    content: '*';
    color: #f56c6c;
  }
}

.copy-btn {
  color: black;
  font-size: 12px;
  padding: 2px;
}
</style>
